import { Provider } from "@angular/core";
import { AccountOffsetLookupService, InventoryLocationService, InventoryMetadataService, InventoryService, InventoryUnitService, ItemAdjustmentService, ItemClassLookupService, ItemClassService, ItemCommodityCodeLookupService, ItemLocationLookupService, ItemLocationService, ItemLookupService, ItemService, ItemStatusLookupService, ItemUdfService, ItemVendorService, LocationCodeLookupService, ShipToLocationLookupService, TransactionCodeLookupService, TransactionService, UnitLookupService, WarehouseLookupService, } from "./services";

export function provideInventory(): Array<Provider>
{
    return [
        TransactionCodeLookupService,
        LocationCodeLookupService,
        ItemLookupService,
        InventoryService,
        InventoryMetadataService,
        WarehouseLookupService,
        UnitLookupService,
        TransactionService,
        ShipToLocationLookupService,
        ItemVendorService,
        ItemUdfService,
        ItemStatusLookupService,
        ItemService,
        ItemLocationService,
        ItemLocationLookupService,
        ItemCommodityCodeLookupService,
        ItemClassService,
        ItemClassLookupService,
        ItemAdjustmentService,
        InventoryUnitService,
        InventoryLocationService,
        AccountOffsetLookupService,
    ];
}
